import { useEffect } from 'react';
import { FaWindows } from "react-icons/fa";
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/navbar/Navbar';
import SEO from '../../components/seo/SEO';
import './style.css';
import React from 'react';






function Download() {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);


  return (
    <>
      <SEO
        title="Downloads | SofChef Local"
        description="Baixe o SofChef Local, o app de controle de impressões e emissões fiscais para o seu restaurante ou bar."
        path="/downloads"
      />

      <Navbar />

      <section className="download-section" id="downloads" role="main" aria-labelledby="download-title">
        <div className="container-download">
          <div className="download-header">
            <h2 className="title" id="download-title">Baixe o SofChef Local agora!</h2>
            <p className="download-subtitle">
              Faça o download do nosso app de controle de impressões de pedidos e emissões fiscais.
            </p>
          </div>

          <div className="download-area">
            <div className="download-info-area">
              <h2 className="title" id="download-sofchef-local-title">SofChef Local</h2>
              <p className="download-subtitle" style={{width: '90%'}}>Nosso app de controle de impressões de pedidos e emissões fiscais</p>

              <a href="https://sofchef.com.br/downloads/local/win" class="download-button">
                <FaWindows fontSize={20} aria-hidden="true" />
                <span>Download Windows</span>
              </a>
            </div>

            <div className="download-image-area">
              <img src={'/images/mockup-desktop.png'} alt="Mockup Desktop" className="download-image" />
            </div>
          </div>

          <div className="download-info">
            <p>Compatível com Windows 10+</p>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );

};

export default Download;
